<template>
  <div>
    <!-- <b-alert show variant="danger" v-if="!order.complete"
      >This order was partially picked before, check history before you
      proceed</b-alert
    > -->
    <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
    <b-alert show variant="danger" v-if="order.item_missing_from_stock">
      Following Models are missing from Stock, please add them then try the
      picking again.
      <ul>
        <li
          :key="index"
          v-for="(model, index) in order.models_missing_from_stock"
        >
          <b>{{ model.model }}</b>
        </li>
      </ul>
    </b-alert>
    <div v-if="!order.item_missing_from_stock">
      <!-- <button class="btn btn-secondary ml-2 float-right" @click="showHistory">
        View History
      </button> -->
      <!-- <button
        to="home"
        class="btn btn-warning float-right"
        @click="printPickingNote"
      >
        Picking Note
      </button> -->
      <!-- <button
        to="home"
        class="btn btn-info float-right mr-2"
        @click="printInvoice"
      >
        Invoice
      </button> -->
      <span class="item_badge_to_pick" v-if="modelToPick != ''">
        <a class="pick_by_click" @click="pickByClick(modelToPick)">
          <span>{{ modelToPick }}</span>
        </a>
      </span>
      <img
        v-if="order.payment_code === 'blockchain'"
        class="float-right mr-3"
        src="/assets/icons/blockchain.png"
      />
    </div>
    <div v-if="!order.item_missing_from_stock" class="scan-model-block">
      <form @submit.prevent="scanItem(scanModel)">
        <div class="form-group form-group-lg">
          <label for="model">Scan item model here</label>
          <input
            ref="model"
            type="text"
            class="form-control text-uppercase"
            id="model"
            placeholder="item model"
            name="model"
            v-model="scanModel"
          />
        </div>
        <button
          type="submit"
          class="btn btn-light"
          style="display:none;"
        ></button>
      </form>

      <b-alert show variant="info" v-if="!scannedItems.length"
        >No items scanned yet, please scan the first item.</b-alert
      >

      <span
        class="danger"
        style="width:30px;height: 10px;margin-right:10px;display: inline-block;"
      ></span
      >Out of Order
      <span
        class="purple"
        style="width:30px;height: 10px;margin-right:10px;display: inline-block;"
      ></span>
      <div class="card mb-3 mt-3" v-if="scannedItems.length">
        <div class="card-header text-white bg-secondary">Picked Items</div>
        <table class="table table-stripped" v-if="scannedItems.length">
          <thead>
            <tr>
              <th>Product</th>
              <th>Model</th>
              <th>Delete</th>
            </tr>
          </thead>
          <tbody>
            <tr
              :key="index"
              v-for="(item, index) in scannedItems"
              :class="{
                'danger text-white': item.outOfOrder
              }"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.model }}</td>
              <td>
                <button
                  class="btn btn-danger btn-xs"
                  @click="deleteItem(index)"
                >
                  Delete
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <button
        class="btn btn-success float-right btn-lg ml-2"
        v-if="scannedItems.length"
        type="button"
        @click="submitPickingNote"
      >
        Submit (Go to shipping)
      </button>
    </div>

    <button
      class="btn btn-info float-right"
      v-if="!scannedItems.length && BRAND == 'IM'"
      type="button"
      @click="outOfStock()"
    >
      Out of stock
    </button>
    <pickingwarning-modal ref="pickingWarningModal"></pickingwarning-modal>
    <ups-modal
      ref="upsModalPopup"
      :upsResponse="upsResponse"
      :order="order"
    ></ups-modal>
    <order-history-modal
      ref="orderHistoryModal"
      :history="order.history"
    ></order-history-modal>
  </div>
</template>

<script>
import PickingwarningModal from "@/components/picking/PickingwarningModal.vue";
import OrderHistoryModal from "@/components/picking/OrderHistoryModal.vue";
import UpsModal from "@/components/picking/UpsModal.vue";

export default {
  name: "shopify-picking-utility",
  props: ["order", "orderId"],
  components: {
    PickingwarningModal,
    UpsModal,
    OrderHistoryModal
  },
  data() {
    return {
      error: null,
      modelToPick: "",
      scannedItems: [],
      scannedItem: "",
      scanModel: "",
      upsResponse: false
    };
  },
  mounted() {
    this.getNextItemToPick();
    this.orderId = this.$route.params.id;
  },
  methods: {
    // printInvoice() {
    //   let url =
    //     this.APIURL + this.BRAND + "/order/invoice/" + this.order.order_id;
    //   window.open(url, "_blank");
    // },
    // printPickingNote() {
    //   let url =
    //     this.APIURL + this.BRAND + "/order/picking-note/" + this.order.order_id;
    //   window.open(url, "_blank");
    // },
    pickByClick(modelToPick) {
      this.scanItem(modelToPick);
    },
    scanItem(model) {
      this.scannedItem = model;
      this.error = "";
      let loader = this.$loading.show();
      let partofOrder = false;
      //check if this item is part of the orde items
      this.order.items.forEach(item => {
        if (
          item.model.toUpperCase().trim() ==
          this.scannedItem.toUpperCase().trim()
        ) {
          //then check if the item already in the scanned items then inc quantity else add it
          item.scanCount++;
          item.outOfOrder = false;
          this.scannedItems.push({
            ...item
          });
          partofOrder = true;
        }
      });

      if (!partofOrder) {
        this.notPartofOrder(loader);
      }

      this.scannedItem = "";
      this.scanModel = "";
      loader.hide();
      this.getNextItemToPick();
    },
    notPartofOrder(loader) {
      let itemModel = this.scannedItem.toUpperCase().trim();
      let outOfOrderItemQty = 1;

      //was this item scanned before ?
      this.scannedItems.forEach(item => {
        //if yes then quantity needed = previous scanned quantity + 1
        if (item.model.toUpperCase().trim() == itemModel.toUpperCase().trim()) {
          outOfOrderItemQty++;
        }
      });

      //does this item with the needed quantity exist in the DB ?
      this.$http
        .get(
          this.APIURL +
            this.BRAND +
            "/stock-exist?model=" +
            itemModel +
            "&qty=" +
            outOfOrderItemQty
        )
        .then(
          response => {
            let data = response.data;
            if (data.status == "success") {
              //if yes then add the item to scanned items in red and set a flag that items out of order scanned = yes
              data.item.outOfOrder = true;
              this.scannedItems.push(data.item);
              this.scannedItem = "";
            } else if (data.status == "not-found") {
              //if no then display a modal popup with error and just a dismiss button
              this.error =
                "The scanned item either doesn't exist or the stocked quantity is not enough.";
            }
            loader.hide();
            this.$refs.model.focus();
          },
          error => {
            console.log(error);
          }
        );
    },
    getNextItemToPick() {
      //loop though order items array and check when scanned quantity is not equal
      //the required quantity then return this item model number
      let modelsToPick = [];
      if (this.order.items.length) {
        this.order.items.forEach(item => {
          if (item.scanCount < item.quantity) {
            modelsToPick.push(item.model);
          }
        });
        if (modelsToPick.length) {
          this.modelToPick = modelsToPick[0];
        } else {
          this.modelToPick = "";
        }
      } else {
        this.modelToPick = "";
      }
    },
    deleteItem(index) {
      this.error = "";
      //get item model
      let model = this.scannedItems[index].model.toUpperCase().trim();
      //search for this item in the order items and descrease the scane count
      this.order.items.forEach(item => {
        if (item.model.toUpperCase().trim() == model) {
          item.scanCount--;
        }
      });
      //remove the item from scanned array
      this.scannedItems.splice(index, 1);
      this.getNextItemToPick();
      this.$refs.model.focus();
    },

    submitPickingNote() {
      this.error = "";
      var outOfOrder = false;
      var qtyMatch = true;

      //check if all order items are matching the scanned items
      this.order.items.forEach(item => {
        if (item.scanCount != item.quantity) {
          qtyMatch = false;
        }
      });

      this.scannedItems.forEach(item => {
        if (item.outOfOrder) {
          outOfOrder = true;
        }
      });

      if (!qtyMatch) {
        this.error = "Order quantities and scanned ones do not match!";
      } else if (outOfOrder) {
        this.$refs.pickingWarningModal.showModal();
      } else {
        this.shipOrder({ weight: this.order.total_weight });
      }
    },
    // requestUpsLabel(orderId) {
    //   let loader = this.$loading.show();

    //   this.$http
    //     .post(this.APIURL + this.BRAND + "/ups/confirm", {
    //       "order-id": orderId
    //     })
    //     .then(
    //       response => {
    //         this.upsResponse = response.data;
    //         //if response fails then show modal
    //         if (this.upsResponse.status == "0") {
    //           this.$refs.upsModalPopup.showModal();
    //           loader.hide();
    //         } else {
    //           this.acceptUpsLabel(
    //             this.upsResponse.ShipmentIdentificationNumber,
    //             loader
    //           );
    //         }
    //       },
    //       error => {
    //         console.log(error);
    //       }
    //     );
    // },
    // acceptUpsLabel(ShipmentIdentificationNumber, loader) {
    //   //send request to accept shipment
    //   this.$http
    //     .post(this.APIURL + this.BRAND + "/ups/accept", {
    //       "shipment-id": ShipmentIdentificationNumber
    //     })
    //     .then(
    //       response => {
    //         this.upsResponse = response.data;
    //         //if response fails then show modal
    //         if (this.upsResponse.status == "0") {
    //           this.$refs.upsModalPopup.showModal();
    //           loader.hide();
    //         } else {
    //           loader.hide();
    //           //open a new page to display the label and trigger print
    //           this.printUpsLabel();
    //           //then shiporder
    //           this.shipOrder({ weight: 0 });
    //         }
    //       },
    //       error => {
    //         loader.hide();
    //         console.log(error);
    //       }
    //     );
    // },
    // printUpsLabel() {
    //   var url = this.APIURL + this.BRAND + "/ups/label/" + this.order.order_id;
    //   window.open(url, "_blank");
    // }
    shipOrder(event) {
      //show loader
      let loader = this.$loading.show();

      let httpData = {
        scanned_items: this.scannedItems,
        order_id: this.orderId
      };

      this.$http.post(this.APIURL + this.BRAND + "/order-ship", httpData).then(
        response => {
          if (response.data.status == "success") {
            //on success navigate to order shipping page
            window.location.href = "/shipping/" + this.orderId;
          } else {
            this.$router.push({ path: "/orders" });
            loader.hide();
          }
        },
        error => {
          console.log(error);
        }
      );
    }
    // showHistory() {
    //   this.$refs.orderHistoryModal.showModal();
    // }
  }
};
</script>
<style scoped>
.purple {
  background-color: #6f42c1;
}
.danger {
  background-color: #dc3545;
}
</style>
